import { AxiosRequestSender } from '@vue-storefront/sdk-axios-request-sender';
import { type OrderData } from 'web/composables/useCustomerOrder';
import { client } from '../client';

type EpicorOrder = {
  OrderHed_Company: string;
  OrderHed_OrderNum: string;
  OrderHed_OrderDate: string;
  Calculated_ShipToAddressList: string;
  OrderHed_OrderAmt: number;
  Customer_Name: string;
  ShipVia_Description: string;
  Calculated_BTAddressList: string;
  Calculated_OrderAddressList: string;
  OrderHed_PONum: string;
  OrderHed_TermsCode: string;
  Terms_Description: string;
  OrderHed_OrderComment: string;
  Calculated_CustNumPartam: string;
};

type EpicorOrderItem = {
  OrderDtl_Company: string;
  OrderDtl_OrderNum: string;
  OrderDtl_PartNum: string;
  OrderDtl_LineDesc: string;
  OrderDtl_UnitPrice: number;
  OrderDtl_OrderQty: number;
  OrderDtl_DocExtPriceDtl: number;
  Calculated_ValueOutstanding: number;
  Calculated_ExtPriceInclDiscount: number;
  Calculated_DiscountedUnitPrice: number;
};

export async function getOrderDetail(id:string): Promise<OrderData> {
  const { user: userData} = useUserSession();
  const apiOrderClient = new AxiosRequestSender(client)
    .setUrl('orderDetail')
    .setMethod('GET')
    .setProps([{id:id, customer_id: userData.value?.epicor_id}])
    .send<EpicorOrder[]>();

  const epicorOrder = await apiOrderClient;
  const orderDetail = epicorOrder[0];

  const apiOrderItemClient = new AxiosRequestSender(client)
    .setUrl('orderItems')
    .setMethod('GET')
    .setProps([{id:id, customer_id: userData.value?.epicor_id}])
    .send<EpicorOrderItem[]>();

  const apiOrderItems = await apiOrderItemClient;
  const productDatas = apiOrderItems?.map(item => ({
    name: item.OrderDtl_PartNum,
    itemDescription: item.OrderDtl_LineDesc,
    quantity: item.OrderDtl_OrderQty,
    price: {
      discount: {
        currency: 'Dollar',
        amount: item.OrderDtl_UnitPrice - item.Calculated_DiscountedUnitPrice,
        precisionAmount: (item.OrderDtl_UnitPrice - item.Calculated_DiscountedUnitPrice).toString(),
      },
      value: {
        currency: 'Dollar',
        amount: item.Calculated_DiscountedUnitPrice,
        precisionAmount: item.Calculated_DiscountedUnitPrice.toString(),
      },
      regularPrice: {
        currency: 'Dollar',
        amount: item.OrderDtl_UnitPrice,
        precisionAmount: item.OrderDtl_UnitPrice.toString(),
      },
      isDiscounted: false,
      wholeSale: {
        currency: 'Dollar',
        amount: item.OrderDtl_UnitPrice,
        precisionAmount: item.OrderDtl_UnitPrice.toString(),
      },
      final:{
        currency: 'Dollar',
        amount: item.Calculated_ExtPriceInclDiscount,
        precisionAmount: item.Calculated_ExtPriceInclDiscount.toString(),
      }
    },
    gallery: [],
    attributes: [],
  }));

  const order: OrderData = {
    id: orderDetail.OrderHed_OrderNum,
    date: orderDetail.OrderHed_OrderDate,
    paymentAmount: orderDetail.OrderHed_OrderAmt,
    paymentMethod: orderDetail.OrderHed_PONum,
    shipping: orderDetail.ShipVia_Description,
    summary: {
      subtotal: orderDetail.OrderHed_OrderAmt,
      delivery: 0,
      estimatedTax: 0,
      total: orderDetail.OrderHed_OrderAmt,
    },
    shippingStrFormat: orderDetail.Calculated_ShipToAddressList.replace(/~~~/, '\n').replace(/~/g, ', '),
    billingStrFormat: orderDetail.Calculated_OrderAddressList.replace(/~~~/, '\n').replace(/~/g, ', '),
    status: orderDetail.Terms_Description,
    products: productDatas,
    customerName: ''
  };

  return order;
}
